import React, { useEffect } from "react";
import DiscountProducts from "../components/Offer/DiscountProducts";
import FeaturedProducts from "../components/Offer/FeaturedProducts";
import TwoForOneProducts from "../components/Offer/TwoForOneProducts";
import BestSellerProducts from "../components/Offer/BestSellerProducts";

export default function OfferPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Ofertas | D&R Soluciones Informáticas";
  }, []);

  return (
    <div>
      <DiscountProducts />
      <FeaturedProducts />
      <BestSellerProducts />
    </div>
  );
}

